(() => {
  const sections = Array.from(document.querySelectorAll("[data-featured-motion]"));
  if (!sections.length) return;

  sections.forEach((section) => {
    const rail = section.querySelector("[data-motion-rail]");
    const shell = section.querySelector("[data-motion-rail-shell]");
    if (!rail || !shell) return;

    let isDown = false;
    let startX = 0;
    let scrollStart = 0;

    const resume = () => {
      isDown = false;
      section.classList.remove("is-dragging");
    };

    rail.addEventListener("pointerdown", (event) => {
      isDown = true;
      startX = event.clientX;
      scrollStart = shell.scrollLeft;
      rail.setPointerCapture(event.pointerId);
      section.classList.add("is-dragging");
    });

    rail.addEventListener("pointermove", (event) => {
      if (!isDown) return;
      shell.scrollLeft = scrollStart + (startX - event.clientX);
    });

    rail.addEventListener("pointerup", resume);
    rail.addEventListener("pointercancel", resume);
    rail.addEventListener("mouseleave", () => {
      if (isDown) resume();
    });
  });
})();
